module.exports = __webpack_public_path__ + "static/media/2.457b3510.png";